import {I18n} from 'react-redux-i18n';
import moment from '../../util/moment';

const FormatedDate = ({date, format}) => {
  if (!date) {
    return '---';
  }

  if (format) {
    return moment(date).format(I18n.t(format));
  }
  return moment(date).format(I18n.t('configuration.dateTimeFormat'));
};

export default FormatedDate;
